import router from '@/router'
import { useUserStore } from '@/store/modules/user'
import { usePermissionStore } from '@/store/modules/permission'

const whiteList = ['/login'] // 真正无需认证的页面

// 辅助函数：打印当前已注册的路由
function logRegisteredRoutes() {
  console.group('当前已注册的路由列表')
  router.getRoutes().forEach(route => {
    console.log(`路径: ${route.path}`, `名称: ${route.name || '未命名'}`, `元信息:`, route.meta)
  })
  console.groupEnd()
}

router.beforeEach(async (to, from, next) => {
  const userStore = useUserStore()
  const permissionStore = usePermissionStore()
  const hasToken = userStore.token
  
  // 设置页面标题
  document.title = to.meta.title ? `联皓云-${to.meta.title}` : '联皓云'

  // 开发环境下打印当前路由信息（生产环境会自动移除）
  if (process.env.NODE_ENV === 'development') {
    //console.log('即将进入的路由:', to)
    // logRegisteredRoutes()
  }
  
  // 1. 处理登录页的特殊情况
  if (to.path === '/login') {
    // 已登录用户访问登录页 → 重定向到首页
    if (hasToken) {
      const firstRoute = getFirstAccessibleRoute(userStore.user.rule)
      next(firstRoute || '/dashboard')
      return
    }
    // 未登录用户访问登录页 → 允许访问
    next()
    return
  }

  // 2. 白名单检查（排除登录页，因为上面已经处理过）
  if (whiteList.includes(to.path)) {
    next()
    return
  }

  // 3. 未登录状态 → 跳转登录页
  if (!hasToken) {
    next(`/login?redirect=${encodeURIComponent(to.fullPath)}`)
    return
  }

  // 4. 已登录状态处理
  try {
    // 动态路由生成逻辑
    if (!permissionStore.dynamicRoutes.length) {
      await permissionStore.generateRoutes()
      next({ ...to, replace: true })
      return
    }

    // 根路径重定向
    if (to.path === '/') {
      const firstRoute = getFirstAccessibleRoute(userStore.user.rule)
      next(firstRoute || '/dashboard')
      return
    }

    // 正常放行
    next()
  } catch (error) {
    console.error('路由处理失败:', error)
    await userStore.resetToken()
    next(`/login?redirect=${encodeURIComponent(to.fullPath)}`)
  }
})

// 辅助函数：获取用户可访问的第一个有效路由
function getFirstAccessibleRoute(rules) {
  return rules.routes[0].path;
}